import { render, staticRenderFns } from "./ExpiredLink.vue?vue&type=template&id=019174ad&scoped=true"
import script from "./ExpiredLink.vue?vue&type=script&lang=ts"
export * from "./ExpiredLink.vue?vue&type=script&lang=ts"
import style0 from "./ExpiredLink.vue?vue&type=style&index=0&id=019174ad&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019174ad",
  null
  
)

export default component.exports